import { render, staticRenderFns } from "./authority-add-member.vue?vue&type=template&id=3ff047a8&scoped=true"
import script from "./authority-add-member.vue?vue&type=script&lang=js"
export * from "./authority-add-member.vue?vue&type=script&lang=js"
import style0 from "./authority-add-member.vue?vue&type=style&index=0&id=3ff047a8&prod&scoped=true&lang=scss"
import style1 from "./authority-add-member.vue?vue&type=style&index=1&id=3ff047a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff047a8",
  null
  
)

export default component.exports